// extracted by mini-css-extract-plugin
export default {"LogosContainer":"Logos_LogosContainer__SaRx1","LogosContent":"Logos_LogosContent__LilW8","LogosHeader":"Logos_LogosHeader__RYKM3"};